import React from 'react'
import { useState } from 'react';
import { useDispatch } from 'react-redux';
import axios from "../../../../Global/axios";
import { setAppError } from "../../../../store/userSlice";

const DeleteArrivalList = ({
  setUpdateData,
  showPromptElement,
  setShowPromptElement,
}) => {
  const [sumbmitLoading, setSubmitLoading] = useState(false);
  const dispatch = useDispatch();
  const token = localStorage.getItem("token");
  const submitHandler = async (e) => {
    e.preventDefault();
    setSubmitLoading(true);

    try {
      const response = await axios.delete(
        `/dashboard/arrival-notification/${showPromptElement?.id}`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      if (response.status === 200) {
        setSubmitLoading(false);
        dispatch(
          setAppError({ msg: response.data.message, color: "bg-green-600" })
        );
        setShowPromptElement({ open: false, id: "" });
        setUpdateData((prev) => !prev);
      }
    } catch (e) {
      setSubmitLoading(false);
      dispatch(setAppError({ msg: e.response.data.message }));
    }
  };
  return (
    <form
      onSubmit={submitHandler}
      className={`fixed z-50 top-0 left-0 min-w-full min-h-screen bg-black/50  justify-center items-center ${
        showPromptElement?.open ? "flex" : "hidden"
      }`}
    >
      <div className="max-w-2xl w-full h-auto  min-h-[14rem] rounded-md bg-white/90 flex justify-center items-center flex-col">
        <h2 className="text-2xl p-4 pb-1 text-center">
          Delete Arrival Notification
        </h2>

        <p className="text-center mt-5">Are you sure you want to delete?</p>

        <div className="flex gap-3 min-w-fit m-5">
          <button
            className="p-1 w-20 rounded-md ring-1 ring-slate-600"
            onClick={() => {
              setShowPromptElement({ open: false, id: "" });
            }}
          >
            NO
          </button>
          <button
            type="submit"
            className="p-1 w-20 rounded-md ring-1 ring-red text-white bg-red"
          >
            {sumbmitLoading ? "Deleting.." : "YES"}
          </button>
        </div>
      </div>
    </form>
  );
};

export default DeleteArrivalList